export default {
  Selected: 'Selected',
  Clear: 'Clear',
  Search: 'Search',
  'No results found': 'No results found',
  'Date-range': 'Date-range',
  Date: 'Date',
  'Add Another': 'Add Another',
  "Select up to": "Select up to",
  "days": "days",
  "Recent": "Recent",
  "Search Entities": "Search Entities",
  "Try searching for an entity’s name, or ID. You can also search for a location.": "Try searching for an entity’s name, or ID. You can also search for a location.",
  "Your recent search history will be shown here the next time you use search.": "Your recent search history will be shown here the next time you use search.",
  "l": "l",
  "gal": "gal",
  "L/100KM": "L/100KM",
  "MPG": "MPG",
  "KM/L": "KM/L",
  "kph": "kph",
  "mph": "mph",
  "kph/s": "kph/s",
  "mph/s": "mph/s",
  "m": "m",
  "ft": "ft",
  "kg": "kg",
  "lbs": "lbs",
  "°C": "°C",
  "°F": "°F",
  "square meters": "square meters",
  "square feet": "square feet",
  "square kilometers": "square kilometers",
  "square miles": "square miles",
  "kPa": "kPa",
  "psi": "psi",
  "tonne": "tonne",
  "ton": "ton",
  "km": "km",
  "mi": "mi",
  "just now": "just now",
  "now": "now",
  "ago": "ago",
  "yesterday at": "yesterday at",
  "weeks": "weeks",
  "hours": "hours",
  "minutes": "minutes",
  "seconds": "seconds",
  "week": "week",
  "day": "day",
  "hour": "hour",
  "minute": "minute",
  "second": "second",
  "wk": "wk",
  "hr": "hr",
  "min": "min",
  "sec": "sec",
  "Enter at least 2 characters to search": "Enter at least 2 characters to search",
  "Keyword": "Keyword",
  "Show by type": "Show by type",
  "Find": "Find",
  "by": "by",
  "Try searching for": "Try searching for",
  "Try searching by keyword.": "Try searching by keyword.",
  "No matches found": "No matches found",
  "Enter atleast two characters to search": "Enter at least two characters to search",
  "Group results": "Group results",
  "Filter for": "Filter for",
  "More": "More",
  "more": "more",
  "Drag and drop images & documents": "Drag and drop images & documents",
  "Upload": "Upload",
  "Upload failed": "Upload failed",
  "Uploads failed": "Uploads failed",
  "Uploaded files have the following issues:": "Uploaded files have the following issues:",
  "File exceeds": "File exceeds",
  "limit": "limit",
  "is not supported. Please upload": "is not supported. Please upload",
  "File is empty or corrupted.": "File is empty or corrupted.",
  "Network error": "Network error",
  "Invalid format or size.": "Invalid format or size.",
  "Supported formats:": "Supported formats:",
  "File Size:": "File Size:",
  "MB Max": "MB Max",
  "of": "of",
  "uploaded": "uploaded",
  "file": "file",
  "files": "files",
  "out of": "out of",
  "Retry": "Retry",
  "Fetch Failed": "Fetch Failed",
  "B": "B",
  "KB": "KB",
  "MB": "MB",
  "GB": "GB",
  "Please upload a document": "Please upload a document",
  "An error occurred with this file.": "An error occurred with this file.",
  "Item": "Item",
  "image": "image",
  "You can only upload up to": "You can only upload up to",
  "and": "and",
  "or": "or",
  "Unknown format": "Unknown format",
  "Please enter numeric values": "Please enter numeric values",
  "Date format": "Date format",
  "Please select a date after": "Please select a date after",
  "Please select a date before": "Please select a date before",
  "Please select a date between": "Please select a date between",
  "Please select a valid date": "Please select a valid date",
  "Please enter a valid date": "Please enter a valid date",
  "Write something...": "Write something...",
  "Esc to": "Esc to",
  "Cancel": "Cancel",
  "Enter": "Enter",
  "to": "to",
  "Save": "Save",
  "Show Filters": "Show Filters",
  "Hide Filters": "Hide Filters",
  "Show deactivated entities": "Show deactivated entities",
  "Show deactivated": "Show deactivated",
  "Deactivated": "Deactivated",
  "No data available": "No data available",
  "Image not available": "Image not available",
  "Video not available": "Video not available",
  "Customize Columns": "Customize Columns",
  "Drag to reorder. Toggle visibility with the eye icon.": "Drag to reorder. Toggle visibility with the eye icon.",
  "Apply": "Apply",
  "results": "results",
  "Table pagination": "Table pagination",
  "Previous page": "Previous page",
  "Next page": "Next page",
  "Press < for quick navigation": "Press < for quick navigation",
  "Press > for quick navigation": "Press > for quick navigation",
  "Last updated:": "Last updated:",
};
